import { useQuery } from '@tanstack/react-query';
import { ROUTES, type Alarm, type AlarmInput, type ClockState } from '@serb/shared';
import { api } from '../../api/client';
import { KEYS } from '../../api/keys';

/** The reminders list. Kept up to date by the live channel after the first load. */
export const useClock = () => useQuery({ queryKey: KEYS.clock, queryFn: () => api.get<ClockState>(ROUTES.api.clock) });

export const clockApi = {
  add: (input: AlarmInput) => api.post<Alarm>(ROUTES.api.alarms, input),
  test: () => api.post<Alarm>(ROUTES.api.alarmTest),
  remove: (id: string) => api.post<{ ok: boolean }>(ROUTES.api.alarmDelete(id)),
};

/** "held to working hours" when it will arrive later than asked */
export const isHeld = (a: Pick<Alarm, 'at' | 'deliverAt'>) => a.deliverAt !== a.at;
